module.exports = __webpack_public_path__ + "static/banner-2-991e2ceed14efb4f1ea2664086b8f9c7.png";